import styled from 'styled-components';

import Icon from '../../../_shared/components/Icon';
import Button from '../../../_shared/components/Button';

export const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 17px 12px;
  height: 61px;
`;

export const HeaderText = styled.div`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  line-height: 24px;
`;

export const ClearButton = styled(Button)`
  display: flex;
  align-items: inherit;
  letter-spacing: ${({ theme }) => theme.LETTER_SPACING.WIDE};
  padding: 0;
  outline: none;
  color: ${({ theme }) => theme.COLORS.TERTIARY};
  height: 14px;
  line-height: 14px;
  background-color: ${({ theme }) => theme.COLORS.TRANSPARENT};
`;

export const CloseIcon = styled(Icon).attrs({
  icon: 'TR5-Clear-X'
})`
  width: 12px;
  height: 12px;
  margin-left: 6px;
`;
